import { type FC, type PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { captureException } from '@sentry/react';

import {
  UnexpectedErrorPage,
  type UnexpectedErrorPageProps,
} from '#apps/client-web/pages/unexpected-error';

export type PageErrorBoundaryProps = Omit<UnexpectedErrorPageProps, 'error'>;

export const PageErrorBoundary: FC<
  PropsWithChildren<PageErrorBoundaryProps>
> = ({ children, ...props }) => (
  <ErrorBoundary
    fallbackRender={({ error }) => (
      <UnexpectedErrorPage error={error} {...props} />
    )}
    onError={(err, info) => captureException(err, { extra: { info } })}>
    {children}
  </ErrorBoundary>
);
